import React from "react";
import cn from "classnames";

export interface ComboxEmptyStateProps {
  children?: React.ReactNode;
  className?: string;
}

export const ComboxEmptyState = ({ children, className }: ComboxEmptyStateProps) => {
  return (
    <div
      className={cn(
        "text-charcoal-300 flex flex-col items-center justify-center gap-2 px-4 py-6 text-center text-sm",
        className,
      )}
    >
      {children || "No results found"}
    </div>
  );
};

export default ComboxEmptyState;
